/**
 * Sesión de idempotencia en vuelo — Portal Cliente Menuee
 *
 * Reutiliza la misma clave mientras un envío E6 está pendiente.
 * Tras éxito, genera clave nueva en el próximo intento.
 */

import { generateIdempotencyKey } from "./idempotency";

/**
 * @returns {{
 *   acquire: () => string,
 *   release: (success: boolean) => void,
 *   isInFlight: () => boolean
 * }}
 */
export function createIdempotencySession() {
  let key = null;
  let inFlight = false;

  return {
    acquire() {
      if (!key) {
        key = generateIdempotencyKey();
      }
      inFlight = true;
      return key;
    },
    release(success) {
      inFlight = false;
      if (success) {
        key = null;
      }
    },
    isInFlight() {
      return inFlight;
    },
  };
}
